export const setting = state => key => {
  return state.settings[key]
}
export const lang = state => state.settings.lang
export const name = state => state.settings.name

export const langs = state => state.langs
export const voices = state => state.voices
